import _errormsg from "./errormsg";

export default function (widget) {
    const m = widget.m;
    const state = widget.state;
    const t = widget.txt;
    const defaultNs = widget.ns + '__map';

    const errormsg = _errormsg(widget);


    const renderZoomControls = function (ctrl, ns) {
        const zoom = state.zoom;
        if (zoom.max === 1) {
            return m('div');
        }
        else {
            const zoomInDisabled = zoom.level === zoom.max;
            const zoomOutDisabled = zoom.level === 1;
            const disabledClass = ns + '__zoom__button--disabled';
            return (
                m('div', {
                        className: ns + '__zoom',
                    },
                    m('button', {
                            className: ns + '__zoom__button' + ns + '__zoom__button--zoomin' +
                            (zoomInDisabled ? disabledClass : ''),
                            onclick: ctrl.zoomIn,
                            disabled: zoomInDisabled,
                            title: t('$zoom--in'),
                        },
                        t('$zoom--in')
                    ),
                    m('button', {
                            className: ns + '__zoom__button' + ns + '__zoom__button--zoomout' +
                            (zoomOutDisabled ? disabledClass : ''),
                            onclick: ctrl.zoomOut,
                            disabled: zoomOutDisabled,
                            title: t('$zoom--out')
                        },
                        t('$zoom--out')
                    )
                )
            );
        }
    };


    const map = {
        controller: function (/*props*/) {
            const ctrl = this;

            let mapElm;
            let isTouching;
            let dragStartX;
            let dragStartY;
            let dragStartX2;
            let dragStartY2;
            let isDragMultiTouch = false;
            let dragStartZoomLevel;
            let dragStartZoomX;
            let dragStartZoomY;
            let dragStartFingerSpace;

            let wasDragging = false;
            ctrl.isDragging = false;
            ctrl.isPinching = false;

            const handleDragStart = function (e) {
                if (!e.button) { // Ignore secondary/auxiliary mouse buttons
                    mapElm = e.currentTarget;
                    const touches = e.touches || [e];
                    dragStartX = touches[0].clientX;
                    dragStartY = touches[0].clientY;
                    if (touches[1]) {
                        e.preventDefault();
                        isDragMultiTouch = true;
                        dragStartX2 = touches[1].clientX;
                        dragStartY2 = touches[1].clientY;
                        const startSpaceX = dragStartX - dragStartX2;
                        const startSpaceY = dragStartY - dragStartY2;
                        dragStartFingerSpace = Math.sqrt(startSpaceX * startSpaceX + startSpaceY * startSpaceY);
                    }
                    const zoom = state.zoom;
                    dragStartZoomLevel = zoom.level;
                    dragStartZoomX = zoom.x;
                    dragStartZoomY = zoom.y;
                    wasDragging = false;
                    isTouching = true;
                    // log( e.type );
                }
            };

            const dragThreshold = 7;
            const pinchThreshold = 30;
            const dragThresholdSquared = dragThreshold * dragThreshold;

            const handleDragging = function (e) {
                if (isTouching) {
                    const touches = e.touches || [e];
                    const xPos = touches[0].clientX;
                    const yPos = touches[0].clientY;
                    const xOffs = dragStartX - xPos;
                    const yOffs = dragStartY - yPos;
                    if (!ctrl.isDragging) {
                        ctrl.isDragging = ( xOffs * xOffs + yOffs * yOffs ) > dragThresholdSquared;
                    }
                    if (ctrl.isDragging) {
                        let levelDelta = 1;
                        let xDelta = xOffs;
                        let yDelta = yOffs;
                        if (isDragMultiTouch) {
                            e.preventDefault();
                            const xPos2 = touches[1].clientX;
                            const yPos2 = touches[1].clientY;
                            xDelta = (xOffs + dragStartX2 - xPos2) / 2;
                            yDelta = (yOffs + dragStartY2 - yPos2) / 2;
                            const spaceX = xPos - xPos2;
                            const spaceY = yPos - yPos2;
                            const fingerSpace = Math.sqrt(spaceX * spaceX + spaceY * spaceY);
                            if (!ctrl.isPinching) {
                                ctrl.isPinching = Math.abs(fingerSpace - dragStartFingerSpace) > pinchThreshold;
                            }
                            if (ctrl.isPinching) {
                                levelDelta = fingerSpace / dragStartFingerSpace;
                            }
                        }
                        const level = levelDelta * dragStartZoomLevel;
                        const x = xDelta / mapElm.offsetWidth + dragStartZoomX;
                        const y = yDelta / mapElm.offsetHeight + dragStartZoomY;
                        state.setZoom(level, x, y);

                        m.redraw();

                        if (level > 1) {
                            e.preventDefault();
                        }

                        // marked as dragging to prevent click event if mouse leaves and enters
                        wasDragging = true;
                    }
                }
            };

            const handleDragEnd = function (/*e*/) {
                isTouching =
                    isDragMultiTouch =
                        false;
                mapElm =
                    dragStartX =
                        dragStartY =
                            dragStartX2 =
                                dragStartY2 =
                                    dragStartZoomLevel =
                                        dragStartZoomX =
                                            dragStartZoomY =
                                                undefined;
                if (ctrl.isDragging) {
                    // Use timeout in order to prevent non-drag-related click events
                    // from making incorrect assumptions about this mouseup/touchend event
                    setTimeout(function () {
                        ctrl.isDragging = false;
                        ctrl.isPinching = false;
                        m.redraw();
                    }, 100);
                }
                // log( e.type );
            };

            let delayedDragActionEnd;

            const handleDragLeave = function (/*e*/) {
                if (ctrl.isDragging) {
                    delayedDragActionEnd = setTimeout(handleDragEnd, 500);
                }
            };
            const handleDragEnter = function (/*e*/) {
                if (ctrl.isDragging) {
                    clearTimeout(delayedDragActionEnd);
                }
            };


            ctrl.setGlobalEvents = function (elm, isRefresh, ctx) {
                if (!isRefresh) {
                    const doc = widget.env.document;
                    elm.addEventListener('mousedown', handleDragStart);
                    elm.addEventListener('touchstart', handleDragStart);
                    doc.addEventListener('mousemove', handleDragging);
                    doc.addEventListener('touchmove', handleDragging);
                    doc.addEventListener('mouseup', handleDragEnd);
                    doc.addEventListener('touchend', handleDragEnd);
                    doc.addEventListener('mouseleave', handleDragLeave);
                    doc.addEventListener('mouseenter', handleDragEnter);

                    ctx.onunload = function () {
                        elm.removeEventListener('mousedown', handleDragStart);
                        elm.removeEventListener('touchstart', handleDragStart);
                        doc.removeEventListener('mousemove', handleDragging);
                        doc.removeEventListener('touchmove', handleDragging);
                        doc.removeEventListener('mouseup', handleDragEnd);
                        doc.removeEventListener('touchend', handleDragEnd);
                        doc.removeEventListener('mouseleave', handleDragLeave);
                        doc.removeEventListener('mouseenter', handleDragEnter);
                    };
                }
            };


            ctrl.zoomIn = function (e) {
                state.zoomIn();
                e.currentTarget.blur();
            };
            ctrl.zoomOut = function (e) {
                state.zoomOut();
                e.currentTarget.blur();
            };
            ctrl.handleDoubleclickZoom = function (e) {
                if (!ctrl.isDragging && !wasDragging) {
                    const mapElm = e.currentTarget;
                    const x = e.layerX / mapElm.offsetWidth;
                    const y = e.layerY / mapElm.offsetHeight;
                    state.toggleZoomIn(x, y);
                }
            };


            const last = {};
            ctrl.maySkipRendering = function (props) {
                const maySkip = props.ns === last.ns &&
                    props.extraClass === last.extraClass &&
                    props.id === last.id &&
                    state.forecastData === state.forecastData &&
                    state.mapImageLoaded === state.mapImageLoaded &&
                    state.useGeo === last.userGeo &&
                    state.zoom === last.zoom;
                last.ns = props.ns;
                last.extraClass = props.extraClass;
                last.id = props.id;
                last.forecastData = state.forecastData;
                last.mapImageLoaded = state.mapImageLoaded;
                last.userGeo = state.userGeo;
                last.zoom = state.zoom;
                return maySkip;
            };

            ctrl.customLayersUnchanged = function (props) {
                const underMap = props.underMap;
                const overMap = props.overMap;
                const unchanged = ( underMap === last.underMap ||
                        (underMap && underMap.subtree === 'retain')
                    ) &&
                    ( overMap === last.overMap ||
                        (overMap && overMap.subtree === 'retain')
                    );
                last.underMap = underMap;
                last.overMap = overMap;
                return unchanged;
            };

        },


        view: function (ctrl, props) {
            props = props || {};

            const mapUnchangd = ctrl.maySkipRendering(props);
            if (mapUnchangd && ctrl.customLayersUnchanged(props)) {
                return {subtree: 'retain'};
            }


            const mapDomid = props.id || widget.domid + '__map';

            let ns = props.ns ? ' ' + props.ns.trim() : defaultNs;
            let extraClass = props.extraClass || '';

            const zoom = state.zoom;
            const draggingClass = ctrl.isDragging ? ns + '-wrapper--is-dragging' : '';
            const forecastdataCatastrophe = state.catastrophe.forecastdata;
            const loadingClass = !state.mapImageLoaded && !forecastdataCatastrophe ? ns + '--is-loading' : '';
            const mapAspectRatio = state.forecastData && state.forecastData.geo && state.forecastData.geo.aspect_ratio || 1;

            return (
                m('div', {
                        className: ns + '-wrapper' + draggingClass,
                        style: 'padding-top:' + (100 / mapAspectRatio) + '%',
                    },

                    (state.forecastData ?
                     m('div', {
                             className: extraClass + ns + loadingClass,
                             id: mapDomid,
                             'aria-live': 'polite',
                             style: zoom.level === 1 ? '' : 'width:' + zoom.size + '%;height:' + zoom.size + '%;top:-' + zoom.top + '%;left:-' + zoom.left + '%;',
                             ondblclick: ctrl.handleDoubleclickZoom,
                             config: ctrl.setGlobalEvents,
                         },

                         props.underMap || '',

                         (!state.mapImageLoaded ? '' :
                          m('img.map', {src: state.forecastData.geo.map_url(), alt: ''})
                         ),

                         props.overMap || '',

                         (!state.userGeo.onMap ? '' :
                          m('div', {
                              className: ns + '__userlocation',
                              style: 'left:' + (100 * state.userGeo.lon_pct) + '%;top:' + (100 * state.userGeo.lat_pct) + '%',
                          })
                         ),

                         (state.mapImageLoaded ? '' :
                          m('div', {className: widget.ns + '__spinner'})
                         )
                     ) :
                     forecastdataCatastrophe ?
                     m('div', {
                             className: extraClass + ns + ns + '--error',
                             id: mapDomid,
                             'aria-live': 'polite',
                         },
                         m(errormsg, {
                             error: forecastdataCatastrophe,
                         })
                     ) :
                     ''
                    ),

                    (!state.forecastData ? '' :
                     renderZoomControls(ctrl, ns)
                    ),

                    (state.userGeo.state !== 'prompt' ? '' :
                     m('button', {
                             className: widget.ns + '__showlocation',
                             onclick: function () {
                                 state.requestGeoPermission();
                             },
                             title: t('$showlocation'),
                         },
                         t('$showlocation')
                     )
                    )
                )
            );

        },

    };


    return map;
}
